import { provideTransloco } from '@jsverse/transloco';
import { TranslocoHttpLoader } from './transloco-loader';
import type { EnvironmentProviders } from '@angular/core';

export const translocoProvider = (isProdMode: boolean): EnvironmentProviders[] =>
  provideTransloco({
    config: {
      availableLangs: ['hu'],
      defaultLang: 'hu',
      prodMode: isProdMode,
      scopes: { keepCasing: true },
      flatten: {
        aot: isProdMode,
      },
    },
    loader: TranslocoHttpLoader,
  });
